import { print } from "graphql/language/printer";

let cache = new Map();

export default ({ app }, inject) => {
  /**
   *
   * @param {object} options
   * @param {import("graphql").DocumentNode} options.query
   * @param {object} options.variables
   *
   * @returns {object}
   */
  const request = async ({ query, variables }) => {
    const operationName = query.definitions.find(
      def => def.kind === "OperationDefinition"
    )?.name?.value;

    if (!query || !operationName) {
      throw new Error("Either query or operation is not provided");
    }

    const queryBody = print(query);

    try {
      const cacheKey = JSON.stringify({ operationName, variables });
      if (process.client && cache.has(cacheKey)) {
        // implement cache on client side only
        return cache.get(cacheKey);
      }

      const previewCookie = app.$cookies.get("io.prismic.preview", {
        parseJSON: false,
      });

      const response = await app.$axios.post(
        "/prismic/api",
        { query: queryBody, variables, operationName },
        {
          headers: {
            Accept: "application/json",
            ...(previewCookie && { "Prismic-ref": previewCookie }),
          },
        }
      );

      const responseData = response.data ?? {};
      if (process.client && responseData) {
        cache.set(cacheKey, responseData);
      }

      return responseData;
    } catch (err) {
      app.$bugsnag.notify(err, e => {
        e.addMetadata("query", queryBody);
        e.addMetadata("variables", variables);
      });
      throw err;
    }
  };

  inject("prismicGql", { request });
};
